<template>
  <v-row v-if="topContributors.length" class="pr-5">
    <v-col cols="12" class="text-right pt-2">
      <span class="caption grey--text text--darken-2 mr-1">
        Top 5 Communicators:
      </span>
      <span
        v-for="(communicator, index) in topContributors"
        :key="index"
        class="mr-1"
      >
        <v-badge
          offset-x="22"
          offset-y="13"
          right
          bottom
          overlap
          small
          color="transparant"
        >
          <v-avatar v-if="index === 0" slot="badge" :size="15">
            <v-img
              :src="require(`@/static/svg/medal.svg`)"
              alt="CRE avatar"
            ></v-img>
          </v-avatar>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <a>
                <v-avatar :size="35" v-on="on">
                  <v-img
                    :src="
                      communicator.picture ||
                        require(`@/static/images/info/user-default.png`)
                    "
                    alt="CRE avatar"
                  ></v-img>
                </v-avatar>
              </a>
            </template>
            <span v-text="communicator.full_name || ''"></span>
            <div>Count: {{ communicator.count }}</div>
          </v-tooltip>
        </v-badge>
      </span>
    </v-col>
  </v-row>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      topContributors: []
    };
  },
  created() {
    this.getTopContributors();
  },
  methods: {
    getTopContributors() {
      this.loading = true;
      this.$axios
        .$get(
          `/api/v1/crm/logs/top-contributors/?organiation=${this.$store.state.shell.currentOrganizationId}`
        )
        .then(response => {
          this.topContributors = response;
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
